import { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import axios from 'axios'
import { api } from '../../../../services/api'

export const useAcompanhamentoApasService = () => {
  const getInitialFilters = () => {
    const searchParams = new URLSearchParams(window.location.search)
    return {
      data_inicial: searchParams.get('data_inicial') || '',
      data_final: searchParams.get('data_final') || '',
      nome_cliente: searchParams.get('nome_cliente') || '',
      empresa: searchParams.get('empresa') || '',
      vendedor: searchParams.get('vendedor') || '',
    }
  }

  const [filtros, setFiltros] = useState(getInitialFilters())
  const [clientesFiltrados, setClientesFiltrados] = useState([])

  const fetchClientesApas = async () => {
    try {
      const response = await api.get('/site/v2/cadastro-cliente/listar-clientes-apas')
      return response.data
    } catch (error) {
      throw new Error('Erro ao buscar clientes APAS')
    }
  }

  const { data, isLoading, error, refetch, isRefetching } = useQuery(['clientes-apas', filtros], fetchClientesApas, {
    refetchOnWindowFocus: true,
    refetchInterval: 60000, // 1 minuto
    staleTime: 30000, // 30 segundos
  })

  useEffect(() => {
    if (!data) return

    try {
      let clientesFiltrados = [...data]

      if (filtros.nome_cliente) {
        clientesFiltrados = clientesFiltrados.filter((cliente) => cliente.nome_cliente?.toLowerCase().includes(filtros.nome_cliente.toLowerCase()))
      }

      if (filtros.empresa) {
        clientesFiltrados = clientesFiltrados.filter((cliente) => cliente.empresa?.toLowerCase().includes(filtros.empresa.toLowerCase()))
      }

      if (filtros.vendedor) {
        clientesFiltrados = clientesFiltrados.filter((cliente) => cliente.nome_vendedor?.toLowerCase().includes(filtros.vendedor.toLowerCase()))
      }

      if (filtros.data_inicial) {
        const dataInicial = new Date(filtros.data_inicial)
        clientesFiltrados = clientesFiltrados.filter((cliente) => {
          const dataCadastro = new Date(cliente.data_cadastro)
          return dataCadastro >= dataInicial
        })
      }

      if (filtros.data_final) {
        const dataFinal = new Date(filtros.data_final)
        dataFinal.setHours(23, 59, 59, 999) // Final do dia
        clientesFiltrados = clientesFiltrados.filter((cliente) => {
          const dataCadastro = new Date(cliente.data_cadastro)
          return dataCadastro <= dataFinal
        })
      }

      setClientesFiltrados(clientesFiltrados)
    } catch (error) {
      console.error('Erro ao processar dados da API:', error)
      setClientesFiltrados([])
    }
  }, [data, filtros])

  const aplicarFiltros = (novosFiltros) => {
    setFiltros(novosFiltros)
  }

  const cadastrarCliente = async (dadosCliente) => {
    try {
      const response = await api.post('/site/v2/cadastro-cliente/cadastro-apas', dadosCliente)

      await refetch() // Atualiza a lista após cadastro
      return response.data
    } catch (error) {
      console.error('Erro ao cadastrar cliente:', error)
      throw new Error(error.response?.data?.mensagem || error.message || 'Erro ao cadastrar cliente')
    }
  }

  return {
    clientes: clientesFiltrados,
    isLoading,
    error,
    isRefetching,
    refetch,
    filtros,
    aplicarFiltros,
    cadastrarCliente,
  }
}
